import createReducer from 'utils/redux/createReducer'
const initialState = false

let checkMode = (mode, action) => {
    if (mode == "view" || mode == "new") return false
    else return action
}

export default createReducer(initialState, {
  // DD: (currentState, action, megastate) => checkMode(megastate.mode, "close")
  // , CLOSE: (currentState, action, megastate) => checkMode(megastate.mode, "close")
    ROLLBACK: (currentState, action) => false
  , CLOSE_NO: (currentState, action) => false
  , DELETE: (currentState, action, megastate) => "delete"
  , DELETE_YES: (currentState, action) => false
  , DELETE_NO: (currentState, action) => false
  , CLOSE_PROMPT: (currentState, action) => false
  // , '@@router/LOCATION_CHANGE': (state, action, megastate) => checkMode(megastate.mode, "close")
})

export let meta = combined => (state, action) => {
    // if (action.type == "CLOSE_PROMPT") {
    //     return {...state, prompt: false}
    // }
    let nextState = combined(state, action)
    //if (state && state.mode != undefined && state.mode != "view" && nextState.routing != state.routing && nextState.mode != "view") {
    if (state && state.mode != undefined && state.mode != "view" && nextState.routing != state.routing && nextState.mode != "view"
    && action.type != '@@INIT' && ((action.type == '@@router/LOCATION_CHANGE' && state.routing && state.routing.locationBeforeTransitions) || action.type == 'CHOOSE_ITEM' || action.type == 'CLOSE')) {
        return {...state, prompt: "close"}
    }
    return nextState
}



// WEBPACK FOOTER //
// ./src/reducers/prompt.js